/** Traductions excelImportAchatModal (FR / AR) */
export const excelImportAchatModalFr = {
  "veuillezSelectionnerFichierExcelValide": "Veuillez sélectionner un fichier Excel valide (.xlsx, .xls) ou CSV",
  "echecImport": "Échec de l'import",
  "importAchatsDepuisExcel": "Import des Achats depuis Excel",
  "1SelectionnerFichierExcel": "1. Sélectionner le fichier Excel",
  "selectionnezFichierExcelXlsxXls": "Sélectionnez un fichier Excel (.xlsx, .xls) ou CSV avec les données d'achat.",
  "selectionnerFichier": "Sélectionner un fichier",
  "aucunFichierChoisi": "Aucun fichier choisi",
  "telechargerModelesExcel": "Télécharger les modèles Excel",
  "utilisezCesModelesCommeReference": "Utilisez ces modèles comme référence pour créer votre fichier Excel",
  "modeleFrancais": "Modèle français",
  "modeleArabe": "Modèle arabe",
  "colonnesRequisesDoiventEtrePresentes": "Colonnes requises (Doivent être présentes)",
  "nomFournisseur": "Nom du fournisseur",
  "nomProduit": "Nom du produit",
  "quantiteNombreSeulementUnitesIndividuelles": "Quantité (nombre) - seulement pour les unités individuelles",
  "prixAchatPieceOuPrix": "Prix d'achat par pièce ou prix par carton (nombre)",
  "prixVentePieceNombre": "Prix de vente par pièce (nombre)",
  "typeEmballageUnitaireOuCarton": "Type d'emballage ('unitaire' ou 'carton')",
  "dateLivraisonJjMmAaaa": "Date de livraison (JJ/MM/AAAA ou JJ-MM-AAAA)",
  "emplacementStockageDefautPrincipal": "Emplacement de stockage (par défaut: 'Principal')",
  "colonnesOptionnellesRecommandees": "Colonnes optionnelles (Recommandées)",
  "codeBarres": "Code-barres",
  "categorie": "Catégorie",
  "sousCategorie": "Sous-catégorie",
  "typeProduit": "Type de produit",
  "dateExpirationJjMmAaaa": "Date d'expiration (JJ/MM/AAAA ou JJ-MM-AAAA)",
  "produitsCartonSeulementSiType": "Produits par carton (seulement si type_emballage='carton')",
  "nombreCartonsSeulementSiType": "Nombre de cartons (seulement si type_emballage='carton')",
  "urlImageProduit": "URL de l'image du produit",
  "noteImportante": "Note importante",
  "colonnesNomFournisseurNomProduit": "Les colonnes nom_fournisseur et nom_produit sont des champs texte. nom_fournisseur doit correspondre exactement à un fournisseur déjà enregistré (aucun fournisseur n'est créé automatiquement). Les produits manquants peuvent être créés; les SKU sont générés automatiquement.",
  "notes": "Notes",
  "donneesSerontAutomatiquementValideesLignes": "Les données seront automatiquement validées et les lignes incorrectes ignorées",
  "produitsFournisseursSontCreesAutomatiquement": "Les produits manquants peuvent être créés automatiquement. Le fournisseur doit déjà exister — sinon la ligne est rejetée.",
  "lotsSontCreesAutomatiquementGestion": "Les lots sont créés automatiquement pour la gestion des stocks",
  "formatsDateSupportesJjMm": "Formats de date supportés : JJ/MM/AAAA, JJ-MM-AAAA, JJ.MM.AAAA",
  "produitsCartonLaissezChampQuantite": "Pour les produits en carton : laissez le champ quantité vide et remplissez produits_par_emballage et nombre_emballages",
  "2ApercuFichier": "2. Aperçu du fichier",
  "back": "Retour",
  "demarrerImport": "Démarrer l'import",
  "3ImportCours": "3. Import en cours...",
  "reussi": "Réussi",
  "erreurs": "Erreurs",
  "avertissements": "Avertissements",
  "ignore": "Ignoré",
  "ignorerErreursContinuer": "Ignorer les erreurs et continuer",
  "importTermineSucces": "Import terminé avec succès!",
  "cancel": "Annuler",
  "close": "Fermer",
  "nouveauFichier": "Nouveau fichier",
  "parseError": "Erreur lors de l'analyse du fichier: {message}",
  "importSuccessStats": "Import réussi!\n\nStatistiques:\n- Réussi: {success}\n- Erreurs: {errors}\n- Total: {total}",
  "importFailed": "Échec de l'import: {message}",
  "previewSummary": "Colonnes trouvées: {cols} | Lignes: {rows}",
  "previewMoreRows": "... et {more} lignes supplémentaires",
  "importProgressRow": "Ligne {current} sur {total}",
  "importErrorsTitle": "Erreurs d'import ({count})",
  "importSuccessDetail": "{success} achats ont été importés avec succès.{errorsPart}",
  "importSuccessErrorsPart": " {errors} lignes avaient des erreurs."
};

export const excelImportAchatModalAr = {
  "veuillezSelectionnerFichierExcelValide": "يرجى اختيار ملف Excel صالح (.xlsx, .xls) أو ملف CSV",
  "echecImport": "فشل في الاستيراد",
  "importAchatsDepuisExcel": "استيراد المشتريات من Excel",
  "1SelectionnerFichierExcel": "1. اختيار ملف Excel",
  "selectionnezFichierExcelXlsxXls": "اختر ملف Excel (.xlsx, .xls) أو ملف CSV يحتوي على بيانات المشتريات.",
  "selectionnerFichier": "اختر ملفًا",
  "aucunFichierChoisi": "لم يتم اختيار أي ملف",
  "telechargerModelesExcel": "تحميل قوالب Excel",
  "utilisezCesModelesCommeReference": "استخدم هذه القوالب كمرجع لإنشاء ملف Excel الخاص بك",
  "modeleFrancais": "قالب فرنسي",
  "modeleArabe": "قالب عربي",
  "colonnesRequisesDoiventEtrePresentes": "الأعمدة المطلوبة (يجب أن تكون موجودة)",
  "nomFournisseur": "اسم المورد",
  "nomProduit": "اسم المنتج",
  "quantiteNombreSeulementUnitesIndividuelles": "الكمية (رقم) - فقط للوحدات الفردية",
  "prixAchatPieceOuPrix": "سعر الشراء للقطعة الواحدة أو سعر الكرتونة (رقم)",
  "prixVentePieceNombre": "سعر البيع للقطعة الواحدة (رقم)",
  "typeEmballageUnitaireOuCarton": "نوع التغليف ('وحدوي' أو 'كرتون')",
  "dateLivraisonJjMmAaaa": "تاريخ التسليم (يوم/شهر/سنة أو يوم-شهر-سنة)",
  "emplacementStockageDefautPrincipal": "موقع التخزين (افتراضي: 'الرئيسي')",
  "colonnesOptionnellesRecommandees": "الأعمدة الاختيارية (موصى بها)",
  "codeBarres": "الباركود",
  "categorie": "الفئة",
  "sousCategorie": "الفئة الفرعية",
  "typeProduit": "نوع المنتج",
  "dateExpirationJjMmAaaa": "تاريخ الانتهاء (يوم/شهر/سنة أو يوم-شهر-سنة)",
  "produitsCartonSeulementSiType": "المنتجات لكل كرتونة (فقط إذا كان نوع التغليف='كرتون')",
  "nombreCartonsSeulementSiType": "عدد الكراتين (فقط إذا كان نوع التغليف='كرتون')",
  "urlImageProduit": "رابط صورة المنتج",
  "noteImportante": "ملاحظة مهمة",
  "colonnesNomFournisseurNomProduit": "الأعمدة nom_fournisseur و nom_produit حقول نصية. يجب أن يطابق nom_fournisseur مورداً مسجلاً مسبقاً (لن يُنشأ مورد تلقائياً). يمكن إنشاء المنتجات الناقصة؛ تُولَّد رموز SKU تلقائياً.",
  "notes": "ملاحظات",
  "donneesSerontAutomatiquementValideesLignes": "سيتم التحقق من البيانات تلقائياً وتجاهل الصفوف غير الصحيحة",
  "produitsFournisseursSontCreesAutomatiquement": "يمكن إنشاء المنتجات الناقصة تلقائياً. يجب أن يكون المورد موجوداً مسبقاً — وإلا يُرفض الصف.",
  "lotsSontCreesAutomatiquementGestion": "يتم إنشاء اللوتات تلقائياً لإدارة المخزون",
  "formatsDateSupportesJjMm": "تنسيقات التاريخ المدعومة: يوم/شهر/سنة، يوم-شهر-سنة، يوم.شهر.سنة",
  "produitsCartonLaissezChampQuantite": "للمنتجات الكرتونية: اترك حقل الكمية فارغاً واملأ produits_par_emballage و nombre_emballages",
  "2ApercuFichier": "2. معاينة الملف",
  "back": "رجوع",
  "demarrerImport": "بدء الاستيراد",
  "3ImportCours": "3. الاستيراد قيد التشغيل...",
  "reussi": "نجح",
  "erreurs": "أخطاء",
  "avertissements": "تحذيرات",
  "ignore": "تم التخطي",
  "ignorerErreursContinuer": "تجاهل الأخطاء والمتابعة",
  "importTermineSucces": "تم الاستيراد بنجاح!",
  "cancel": "إلغاء",
  "close": "إغلاق",
  "nouveauFichier": "ملف جديد",
  "parseError": "خطأ في تحليل الملف: {message}",
  "importSuccessStats": "تم الاستيراد بنجاح!\n\nالإحصائيات:\n- نجح: {success}\n- أخطاء: {errors}\n- المجموع: {total}",
  "importFailed": "فشل في الاستيراد: {message}",
  "previewSummary": "الأعمدة الموجودة: {cols} | الصفوف: {rows}",
  "previewMoreRows": "... و {more} صفوف أخرى",
  "importProgressRow": "الصف {current} من {total}",
  "importErrorsTitle": "أخطاء الاستيراد ({count})",
  "importSuccessDetail": "تم استيراد {success} مشتريات بنجاح.{errorsPart}",
  "importSuccessErrorsPart": " {errors} صفوف بها أخطاء."
};
